import cn from 'classnames';
import star from '@packages/shared/assets/star.svg';
import Image from '@packages/shared/core/common/components/common/Image';
import { Expert, getExpertTotalReviewCount } from '@packages/shared/core/experts/entities';
import styles from './ChatExpert.module.scss';

type ChatExpertProps = {
  className?: string;
  expert: Expert;
};

export const ChatExpert = ({ className = '', expert }: ChatExpertProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.info}>
        <Image type="future" src={expert.image} alt={expert.name} className={styles.avatar} width={40} height={40} />

        <div>
          <span className={styles.name}>{expert.name}</span>

          <span className={styles.description}>Nebula Psychic</span>
        </div>
      </div>

      <div>
        <div className={styles.ratingWrapper}>
          {expert.rating}

          <Image className={styles.rating} type="future" src={star} width={12} height={12} alt="rating" />
        </div>

        <span className={styles.reviews}>{getExpertTotalReviewCount(expert)} reviews</span>
      </div>
    </div>
  );
};

export default ChatExpert;
